import React from 'react';
import { usePhotosphereQuality } from '@/app/providers/PhotosphereQualityProvider';
import ToggleFFXIV from './ToggleFFXIV';
import TooltipWithIconFFXIV from './TooltipWithIconFFXIV';
import { useTranslation } from '@/hooks/useTranslation';

const PhotosphereQualitySelector = () => {
    const { quality, setQuality } = usePhotosphereQuality();
    const { t } = useTranslation();

    return (
        <div className="space-y-1">
            <div className="flex justify-between items-center gap-5">
                <div className="text-[#EEEEEE] text-lg text-shadow shadow-black/70 whitespace-nowrap">{t('settings.photosphereQuality.title')}</div>
                <TooltipWithIconFFXIV
                    position="left"
                    text={t('settings.photosphereQuality.tooltip')}
                />
            </div>
            <div className="ml-3 flex flex-col gap-0.5">
                <ToggleFFXIV
                    value={quality === 'light'}
                    onChange={() => setQuality('light')}
                    text={t('settings.photosphereQuality.light')}
                />
                <ToggleFFXIV
                    value={quality === 'medium'}
                    onChange={() => setQuality('medium')}
                    text={t('settings.photosphereQuality.medium')}
                />
                <ToggleFFXIV
                    value={quality === 'heavy'}
                    onChange={() => setQuality('heavy')}
                    text={t('settings.photosphereQuality.heavy')}
                />
            </div>
        </div >
    );
};

export default PhotosphereQualitySelector;